const StakingHero = () => {
  return (
    <section className="hero relative py-20">
      <div className="container">
        <div className="mx-auto max-w-4xl pt-24 text-center">
          <h1 className="font-display text-5xl text-jacarta-700 dark:text-white lg:text-6xl xl:text-7xl">
            Stake your tokens
          </h1>
        </div>
      </div>
    </section>
  )
}

export default StakingHero
